const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const API = {
  baseUrl: development ? 'https://192.168.11.2/api/v1' : 'https://otower588.com/api/v1',
  // baseUrl: development  ?  'http://localhost:88/api/v1'  : '/api/v1',
  //baseUrl: '/api/v1',
}
export const Config = {
  app: {
    name: 'HomeCare',
  },
  basename: '/',
  //basename: development ? '' : '/backend/web/homecare/',
  //basename: '',
  timezone: 'Asia/Bangkok',
  pager: {
    limit: 20,
  },
  listGrid: {
    gutter: 6,
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 4,
    xxl: 6,
  },
  button: {
    loadMore: {
      text: 'ดูเพิ่มเติม...',
      type: 'info',
      block: true,
      icon: 'down',
      shape: 'round',
    },
  },
  menu: {
    edit: 'แก้ไข',
    view: 'ดู',
  },
  notification: {
    header: 'การแจ้งเตือน',
    statusColor: {
      '-2': {
        background: '#d0335f',
        color: '#ffffff',
      },
      '-1': {
        background: '#d0335f',
        color: '#ffffff',
      },
      '1': {
        background: '#4caf50',
        color: '#ffffff',
      },
      '2': {
        background: '#f6b717',
        color: '#ffffff',
      },
      '3': {
        background: '#5f5f5f',
        color: '#ffffff',
      },
      '4': {
        background: '#5f5f5f',
        color: '#ffffff',
      },
      '5': {
        background: '#5f5f5f',
        color: '#ffffff',
      },
    },
  },
  job: {
    header: 'งานซ่อม',
    // jobStatus: {
    //   '-2': { background: '#d0335f', color: '#ffffff' },
    //   '-1': { background: '#d0335f', color: '#ffffff' },
    //   '1': { background: '#4caf50', color: '#ffffff' },
    //   '2': { background: '#f6b717', color: '#ffffff' },
    //   '3': { background: '#5f5f5f', color: '#ffffff' },
    //   '4': { background: '#5f5f5f', color: '#ffffff' },
    //   '5': { background: '#5f5f5f', color: '#ffffff' },
    // },
    dateDiffColor: {
      today: 'cyan',
      pass: 'red',
      future: 'geekblue',
    },
    status: {
      POSTPONE: {
        value: -2,
        text: 'เลื่อนนัดหมาย',
      }, // เลื่อนนัดหมาย
      CANCELED: {
        value: -1,
        text: 'ยกเลิกแล้ว',
      }, // ยกเลิกแล้ว
      OPEN: {
        value: 1,
        text: 'รอดำเนินการ',
      }, // รอดำเนินการ
      ASSIGNED: {
        value: 2,
        text: 'มอบหมายงานแล้ว',
      }, // มอบหมายงานแล้ว
      REJECTED: {
        value: 5,
        text: 'ปฏิเสธงาน',
      }, // ปฏิเสธงาน
      PROCEED: {
        value: 4,
        text: 'อยู่ระหว่างดำเนินการซ่อม',
      }, // อยู่ระหว่างดำเนินการซ่อม
      COMPLETE: {
        value: 3,
        text: 'ปิดงาน',
      }, // ปิดงาน
    },
  },
  // complaint: {
  //   header: 'ร้องเรียน',
  //   status: {
  //     '-1': { background: '#d0335f', color: '#ffffff' },
  //     '1': { background: '#4caf50', color: '#ffffff' },
  //     '2': { background: '#f6b717', color: '#ffffff' },
  //     '3': { background: '#5f5f5f', color: '#ffffff' },
  //   },
  // },
  informfix: {
    defaultImage: '/srcassetsimagesinformfixicon-home.png',
    workStatusColor: {
      '-1': '#ffcdd2',
      '1': '#b2ebf2',
      '2': '#fff9c4',
      '3': '#fafafa',
    },
    workStatus: {
      '-1': {
        background: '#d0335f',
        color: '#ffffff',
      },
      '1': {
        background: '#4caf50',
        color: '#ffffff',
      },
      '2': {
        background: '#f6b717',
        color: '#ffffff',
      },
      '3': {
        background: '#5f5f5f',
        color: '#ffffff',
      },
    },
    status: {
      REJECTED: {
        value: -2,
        text: 'ปฏิเสธใบแจ้ง',
      }, // ปฏิเสธใบแจ้ง
      CANCELED: {
        value: -1,
        text: 'ยกเลิกแล้ว',
      },
      // ฉบับร่าง
      DRAFT: {
        value: 6,
        text: 'ฉบับร่าง',
      },
      OPEN: {
        value: 1,
        text: 'รอดำเนินการ',
      },
      // รอดำเนินการ
      // WAIT: { value: 4, text: 'รอยืนยัน' }, // รอยืนยัน
      // CONFIRMED: { value: 5, text: 'ยันยันแล้ว' }, // ยันยันแล้ว
      PROCEED: {
        value: 2,
        text: 'อยู่ระหว่างดำเนินการ',
      }, // อยู่ระหว่างดำเนินการ
      COMPLETE: {
        value: 3,
        text: 'เสร็จเรียบร้อย',
      }, // เสร็จเรียบร้อย
    },
  },
  sidebarItems: [
    {
      key: 'dashboard',
      label: 'หน้าแรก',
      icon: 'dashboard',
      to: '/',
    },
    // {
    //   key: 'notification',
    //   label: 'แจ้งเตือน',
    //   icon: 'home',
    //   to: '/notifications',
    // },
    {
      key: 'jobs',
      label: 'ปฏิทินงานซ่อม',
      icon: 'file',
      to: '/calendar',
    },
    {
      key: 'inform',
      label: 'ใบแจ้งซ่อม',
      icon: 'file',
      to: '/informfix',
      children: [
        {
          key: 'manage-inform-list',
          label: 'ใบแจ้งซ่อม(List)',
          icon: 'file',
          to: '/informfix/pending',
        },
        {
          key: 'manage-inform-card',
          label: 'ใบแจ้งซ่อม(Card)',
          icon: 'file',
          to: '/informfix',
        },
        // {
        //   key: "view-inform-waitconfirm",
        //   label: "รอยืนยันนัดหมาย",
        //   icon: "file",
        //   to: "/informfix/waitconfirm",
        // },
      ],
    },
    {
      key: 'manage-job',
      label: 'งาน',
      icon: 'file',
      // to: "/informfix/pending",
      children: [
        {
          key: 'jobs-add',
          label: 'เพิ่มคิวงาน/จ่ายงาน',
          icon: 'file',
          to: '/jobs/proceed',
        },
        {
          key: 'jobs-send',
          label: 'งานรอยืนยันลูกค้า',
          icon: 'file',
          to: '/jobs/send',
        },
        {
          key: 'jobs3',
          label: 'จัดการงานซ่อม',
          icon: 'file',
          to: '/jobs',
        },
        // {
        //   key: "manage-task",
        //   label: "ใบแจ้งซ่อม",
        //   icon: "file",
        //   to: "/informfix/pending",
        // },
        // {
        //   key: "task-inform-reassign",
        //   label: "รอเปลี่ยนวันนัดหมาย",
        //   icon: "file",
        //   to: "/informfix/task-again",
        // },
      ],
    },
    {
      key: 'home',
      label: 'โครงการและบ้าน',
      icon: 'home',
      to: '/projects',
    },
    // { key: 'weather', label: 'พยากรณ์อากาศ', icon: 'file', to: '/weather-today' },
    // { key: 'complaint', label: 'ร้องเรียน', icon: 'file', to: '/complaint' },
    // {
    //   key: 'maintenance-fee',
    //   label: 'แจ้งหนี้/ค่าส่วนกลาง',
    //   icon: 'bug',
    //   to: '/maintenance-fee',
    //   children: [
    //     {
    //       key: 'maintenance-fee-add',
    //       label: 'แจ้งหนี้/ค่าส่วนกลาง',
    //       icon: 'bug',
    //       to: '/maintenance-fee',
    //     },
    //     {
    //       key: 'maintenance-fee-setting',
    //       label: 'ตั้งค่า',
    //       icon: 'cog',
    //       to: '/maintenance-fee/setting',
    //     },
    //   ],
    // },
    {
      key: 'basic-setting',
      label: 'ข้อมูลพืันฐาน',
      icon: 'setting',
      children: [
        {
          key: 'technicial',
          label: 'ช่าง',
          icon: 'user',
          to: '/technicians',
        },
        {
          key: 'informfix-group',
          label: 'หมวดหมู่งานซ่อม',
          icon: 'tool',
          to: '/job-group',
        },
        {
          key: 'member',
          label: 'สมาชิก/ลูกบ้าน',
          icon: 'user',
          to: '/members',
        },
      ],
    },
    // { key: "send", label: "ติดต่อ", icon: "contact", to: "/contact" }
  ],
  error: {
    401: {
      message: 'เซสชั่นหมดอายุแล้ว! โปรดเข้าสู่ระบบใหม่อีกครั้ง',
    },
    403: {
      message: 'ขออภัย! คุณไม่มีสิทธิ์ใช้งานหน้านี้',
    },
    404: {
      message: 'ไม่พบข้อมูล',
    },
    422: {
      message: 'โปรดกรอกข้อมูลให้ถูกต้อง',
    },
  },
  form: {
    formItemLayout: {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 6,
        },
        md: {
          span: 6,
        },
        lg: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 18,
        },
        md: {
          span: 16,
        },
        lg: {
          span: 14,
        },
      },
    },
    buttonItemLayout: {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 18,
          offset: 6,
        },
        md: {
          span: 18,
          offset: 6,
        },
        lg: {
          span: 20,
          offset: 5,
        },
      },
    },
  },
}
